import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Router, Route, Switch, Redirect } from 'react-router-dom';

import styles from './App.module.scss';
import { THEME } from './config/commons';
import { history } from './helpers/history';
import { Store } from './state/store.interface';
import DetailAnalysis from './pages/Analysis-Detail/DetailAnalysis';
import { getCurrentTheme } from './utils/theme';
import { setTheme } from './pages/Analysis-Detail/detailAnalysisSlice';

function App () {
  const defaultPath = '/analysis/:id/:token';
  const dispatch = useDispatch();
  const { theme } = useSelector((state: Store) => state.detail);
  const isLightTheme = theme === THEME.LIGHT;

  useEffect(() => {
    const theme = getCurrentTheme();
    dispatch(setTheme(theme));
  }, []);

  useEffect(() => {
    document.body.classList.add(isLightTheme ? styles.bodyLight : styles.bodyDark);
    document.body.classList.remove(isLightTheme ? styles.bodyDark : styles.bodyLight);
  }, [isLightTheme]);


  return (
    <Router history={history}>
      <Switch>
        <Route exact path='/'>
          <Redirect to={defaultPath} />
        </Route>
        <Route path={defaultPath} component={DetailAnalysis} />
        <Redirect from='*' to='/' />
      </Switch>
    </Router>
  );
}

export default App;
